import { track, logError } from '@tracking';
import getShopDeliveryTime from '@utils/tracking/getShopDeliveryTime';
import getShopId from '@core/reducers/shop/selectors/getShopId';
import getBusinessType from '@results/selectors/getBusinessType';
import getCartIsPickUp from '@core/reducers/cart/selectors/getCartIsPickUp';
import getCartDeliveryTimeExpected from '@core/reducers/cart/selectors/getCartDeliveryTimeExpected';
import getDistanceVendor from '@shopDetails/selectors/getDistanceVendor';
import { formatDistance } from '@shopDetails/utils/pickup';
import { NOT_SET } from '@utils/tracking/constants';
import { categoryType } from '@services/routes.service';

const EVENT = 'pickup_selector.clicked';

const trackTogglePickupClicked = () => (_, getState) => {
  try {
    const { location } = window;
    const state = getState();
    const shopId = getShopId(state);
    const businessType = getBusinessType(state);
    const screenType = categoryType(location);
    const orderPickup = Boolean(getCartIsPickUp(state));
    const distanceVendor = getDistanceVendor(state)?.distance;
    const discount = NOT_SET;
    const deliveryTime = getCartDeliveryTimeExpected(state);
    const shopDeliveryTime = getShopDeliveryTime({
      isPickup: orderPickup,
      deliveryTime,
    });

    const payload = {
      orderPickup,
      screenType,
      shopDeliveryTime,
      discount,
      shopDistance: distanceVendor ? formatDistance(distanceVendor) : NOT_SET,
      shopId,
      businessType,
    };

    track(EVENT, payload);
  } catch (error) {
    logError(EVENT, error);
  }
};

export default trackTogglePickupClicked;
